module.exports = ".home-bg .single-box ul {\n  margin-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main